// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__UUjfv","footer":"ModalUpdate_footer__covoG"};